<template>
  <div v-if="product" ref="productDetailsCtaRef" class="grow" :class="[{ 'w-full mt-2': !isInlineSizeSelector }]">
    <template v-if="isComingSoon || isOutOfStock">
      <product-notify-me v-if="isNotifyMe" class="w-full" :size="ctaSize" />
      <vf-button
        v-else
        class="w-full"
        disabled
        :loading="pending"
        :size="ctaSize"
      >
        {{ isComingSoon ? (product.badge || product.eyebrow)?.label : $t.outOfStock }}
      </vf-button>
    </template>
    <template v-else>
      <vf-button
        id="pdp-add-to-cart"
        aria-live="polite"
        class="w-full"
        :class="[{ 'c-white': isSignInToBuy && theme }]"
        :class-content="{ 'w-full between': $feature.showPriceInCtas }"
        :disabled="!pending && (addToCartLoading || checkoutCtaLoading)"
        :loading="addToCartLoading && !checkoutCtaLoading"
        :size="ctaSize"
        :theme="isSignInToBuy ? theme : undefined"
        :variant="isSignInToBuy && theme ? 'themable' : 'primary'"
        @click="handleNextAttribute({}, () => addToCart())"
      >
        {{ isSignInToBuy ? $t.signInToBuy : $t.addToCart }}
        <product-pricing
          v-if="$feature.showPriceInCtas"
          class-current="c-brand-5"
          :currency="product.currency"
          hide-strikethrough-price
          :price="product.price"
        />
      </vf-button>
    </template>
  </div>
</template>

<script lang="ts" setup>
const {
  details: { ctaSize }
} = useAppConfig().pages.pdp
const { card: { signInToBuyCta: { theme } } } = useAppConfig().components.product

const {
  addToCart,
  addToCartLoading,
  checkoutCtaLoading,
  handleNextAttribute,
  isComingSoon,
  isNotifyMe,
  isOutOfStock,
  isSignInToBuy,
  pending,
  product,
} = usePdp()
const productDetailsCtaRef = useState<HTMLElement>('productDetailsCtaRef')
const isInlineSizeSelector = computed(() => product.value?.attributes.length === 2)
</script>
